export const SpaceApi = Symbol.for('SpaceApi');
